import styled from "styled-components";

export const ConsoleOrganizationPageContainer = styled.div`
  width: 100%;

  margin: 5rem auto;
  padding: 0 1rem;

  @media (max-width: 850px) {
    margin-top: 2rem;
  }

  > .loader {
    width: fit-content;
    margin: 0 auto;
  }

  .MuiDataGrid-columnHeadersInner:has(> div[role="row"]) {
    div[role="row"] {
      width: 100% !important;
    }
  }
`;
